module.exports = __webpack_public_path__ + "static/media/re4.ce203408.jpg";